/**
 * Builds a prop bag for `v-bind` on @hypercodestudio/basler-components.
 *
 * Props not yet declared in the installed components version are ignored at
 * runtime (fallthrough) but must not be passed as typed bindings — that would
 * break `nuxi typecheck`. Once basler-components adds the props, they apply
 * automatically without webapp changes.
 */
export function toForwardCompatProps(
  props: Record<string, string | undefined>
): Record<string, string> {
  return Object.fromEntries(
    Object.entries(props).filter(
      (entry): entry is [string, string] =>
        typeof entry[1] === 'string' && entry[1].length > 0
    )
  );
}
